/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ows-abacus-contract
 * OpenAPI spec version: 1.0.0
 */
import type {
  ContractLifecycleResponse,
  ContractResponse,
  ContractsResponse,
  DataloadContractsResponse,
  GetContractHeaders,
  GetContractLifecyclePathParameters,
  GetContractPathParameters,
  GetContractsBody,
  GetHealthHeaders,
  HealthResponse,
  ReactivateContractHeaders,
  ReactivateContractPathParameters,
  TerminateContractBody,
  TerminateContractHeaders,
  TerminateContractPathParameters,
  UpdateContractBody,
  UpdateContractHeaders,
  UpdateContractPathParameters,
} from "./types";
/**
 * Retrieves contract details
 */
export const getGetContractUrl = ({
  contractId,
}: GetContractPathParameters) => {
  return `/contract/${contractId}/`;
};
/**
 * Update contract details for a specified contract
 */
export const getUpdateContractUrl = ({
  contractId,
}: UpdateContractPathParameters) => {
  return `/contract/${contractId}/`;
};
/**
 * Get the contract lifecycle associated to the specified contract
 */
export const getGetContractLifecycleUrl = ({
  contractId,
}: GetContractLifecyclePathParameters) => {
  return `/contract/${contractId}/contract-lifecycle/`;
};
/**
 * Terminate a contract
 */
export const getTerminateContractUrl = ({
  contractId,
}: TerminateContractPathParameters) => {
  return `/contract/${contractId}/terminate/`;
};
/**
 * Reactivate a contract
 */
export const getReactivateContractUrl = ({
  contractId,
}: ReactivateContractPathParameters) => {
  return `/contract/${contractId}/reactivate/`;
};
/**
 * Get a list of contracts by contract_id
 */
export const getGetContractsUrl = () => {
  return `/contracts/`;
};
/**
 * Get a list of contracts by contract_id
 */
export const getDataloadContractsUrl = () => {
  return `/contracts/dataloader/`;
};
/**
 * Check the health of the application.
 */
export const getGetHealthUrl = () => {
  return `/hello/`;
};
/**
 * Generated by @abacus/api-client-generator
 * Do not edit manually.
 */
import { type Logger, type HeaderProvider } from "@abacus/common";

import { type Throttler } from "@abacus/throttlers";

import { ApiResponse } from "./common";

export interface ApiConfig {
  auth?: HeaderProvider;
  baseUrl?: string;
  logger?: Logger;
  throttler?: Throttler;
}

export class OwsAbacusContractClient {
  auth?: HeaderProvider;
  baseUrl: string;
  logger?: Logger;
  throttler?: Throttler;

  constructor(config?: ApiConfig) {
    this.auth = config?.auth;
    this.baseUrl = config?.baseUrl ?? `https://localhost:8080`;
    this.logger = config?.logger;
    this.throttler = config?.throttler;
  }

  async _fetch<T>(url: string, options: RequestInit): Promise<ApiResponse<T>> {
    // On request
    url = await this._onRequest(url, options);
    // Make request
    const response = await fetch(url, options);
    // Get data
    const data = await this._getData<T>(response);
    const headers = Object.fromEntries(response.headers.entries());
    // Return response
    return { data, headers, status: response.status };
  }

  private _getData<T>(res: Response): Promise<T> {
    const contentType = res.headers.get("content-type");
    if (contentType) {
      if (contentType.includes("application/json")) {
        return res.json() as Promise<T>;
      }
      if (contentType && contentType.includes("application/pdf")) {
        return res.blob() as Promise<T>;
      }
    }
    return res.text() as Promise<T>;
  }

  private async _getHeaders(
    headers?: Record<string, string>,
  ): Promise<Record<string, string>> {
    return {
      ...(await this.auth?.getHeaders()),
      ...headers,
    };
  }

  private async _onRequest(url: string, options: RequestInit): Promise<string> {
    // Throttle the request
    await this.throttler?.wait();
    // Get URL
    url = url = `${this.baseUrl}${url}`;
    // Add Headers
    const headers = options.headers as Record<string, string>;
    options.headers = await this._getHeaders(headers);
    // Log the request
    this.logger?.debug(`Requesting ${options.method} ${url}`);
    return url;
  }

  async getContract(
    { contractId }: GetContractPathParameters,
    headers?: GetContractHeaders,
    options?: RequestInit,
  ) {
    {
      return this._fetch<ContractResponse>(getGetContractUrl({ contractId }), {
        ...options,
        method: "GET",
        headers: { ...headers, ...options?.headers },
      });
    }
  }

  async updateContract(
    { contractId }: UpdateContractPathParameters,
    updateContractBody: UpdateContractBody,
    headers?: UpdateContractHeaders,
    options?: RequestInit,
  ) {
    {
      return this._fetch<ContractResponse>(
        getUpdateContractUrl({ contractId }),
        {
          ...options,
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            ...headers,
            ...options?.headers,
          },
          body: JSON.stringify(updateContractBody),
        },
      );
    }
  }

  async getContractLifecycle(
    { contractId }: GetContractLifecyclePathParameters,
    options?: RequestInit,
  ) {
    {
      return this._fetch<ContractLifecycleResponse>(
        getGetContractLifecycleUrl({ contractId }),
        {
          ...options,
          method: "GET",
        },
      );
    }
  }

  async terminateContract(
    { contractId }: TerminateContractPathParameters,
    terminateContractBody: TerminateContractBody,
    headers?: TerminateContractHeaders,
    options?: RequestInit,
  ) {
    {
      return this._fetch<ContractResponse>(
        getTerminateContractUrl({ contractId }),
        {
          ...options,
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            ...headers,
            ...options?.headers,
          },
          body: JSON.stringify(terminateContractBody),
        },
      );
    }
  }

  async reactivateContract(
    { contractId }: ReactivateContractPathParameters,
    headers?: ReactivateContractHeaders,
    options?: RequestInit,
  ) {
    {
      return this._fetch<ContractResponse>(
        getReactivateContractUrl({ contractId }),
        {
          ...options,
          method: "PUT",
          headers: { ...headers, ...options?.headers },
        },
      );
    }
  }

  async getContracts(
    getContractsBody: GetContractsBody,
    options?: RequestInit,
  ) {
    {
      return this._fetch<ContractsResponse>(getGetContractsUrl(), {
        ...options,
        method: "POST",
        headers: { "Content-Type": "application/json", ...options?.headers },
        body: JSON.stringify(getContractsBody),
      });
    }
  }

  async dataloadContracts(
    getContractsBody: GetContractsBody,
    options?: RequestInit,
  ) {
    {
      return this._fetch<DataloadContractsResponse>(getDataloadContractsUrl(), {
        ...options,
        method: "POST",
        headers: { "Content-Type": "application/json", ...options?.headers },
        body: JSON.stringify(getContractsBody),
      });
    }
  }

  async getHealth(headers?: GetHealthHeaders, options?: RequestInit) {
    {
      return this._fetch<HealthResponse>(getGetHealthUrl(), {
        ...options,
        method: "GET",
        headers: { ...headers, ...options?.headers },
      });
    }
  }
}
